<template>
  <div v-if="imageBase64">
    <div v-if="cropPopupVisible">
      <vue-cropper
        :aspectRatio="aspectRatio"
        :src="imageBase64"
        alt="Image Crop"
        ref="cropper"
        class="cropper"
        :view-mode="2"
        style="width: 80%; margin: 0 auto 15px"
      ></vue-cropper>
    </div>
    <div class="flex mt-3 items-center">
      <vs-button
        @click="rotate(90)"
        icon="icon-rotate-cw"
        icon-pack="feather"
        style="width: 100px !important"
        color="primary"
        type="border"
      />
      <vs-button
        @click="cropImage"
        icon="check"
        class="w-full mx-5"
        color="primary"
        >تایید</vs-button
      >
      <vs-button
        @click="rotate(-90)"
        icon="icon-rotate-ccw"
        icon-pack="feather"
        style="width: 100px !important"
        color="primary"
        type="border"
      />
    </div>
  </div>
  <loader v-else></loader>
</template>

<script>
import VueCropper from "vue-cropperjs";

export default {
  name: "Cropper",
  components: { VueCropper },
  props: {
    imageBase64: {
      type: String,
      required: true,
    },
    cropPopupVisible: {
      type: Boolean,
      required: true,
    },
    aspectRatio: {
      type: Number,
      required: true,
      default: 0,
    },
    fileType: {
      type: String,
      required: true,
    },
  },
  methods: {
    cropImage() {
      const canvas = this.$refs.cropper.cropper.getCroppedCanvas();

      canvas.toBlob(
        (blob) => {
          this.$emit("cropImage", blob);
        },
        this.fileType,
        0.3
      );
    },
    rotate(degree) {
      this.$refs.cropper.cropper.rotate(degree);
    },
  },
};
</script>
